export default function AdminServicios() {
  return (
    <div>
      <h1 className="text-3xl font-bold text-gradient mb-8">Gestión de Servicios</h1>
      <p className="text-gray-300">Aquí podrás crear, editar y gestionar los servicios de Royal Software.</p>
    </div>
  )
}
